import { utils, verifySignature } from '@tradetrust-tt/tradetrust';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const verifyOASignature = /* @__PURE__ */ __name(async (document) => {
  if (utils.isWrappedV2Document(document) || utils.isWrappedV3Document(document)) {
    return verifySignature(document);
  } else {
    return false;
  }
}, "verifyOASignature");

export { verifyOASignature };
